"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const antd_1 = require("antd");
const lodash_1 = __importDefault(require("lodash"));
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const ProjectModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ProjectModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const icons_1 = require("@ant-design/icons");
const PageContent_1 = require("../../../common/widget/PageContent");
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const ProjectCardTitle_1 = require("src/configeek_assets/src/components/loggedIn/content/projects/components/ProjectCardTitle");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const ProjectsPage = () => {
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const projectsDataSource = lodash_1.default.sortBy(projectsDataContext.getProjects(), p => -p.view.project.createdTimeSeconds);
    const isMounted = (0, isMounted_1.default)();
    const [projectProfileViewInModal, setProjectProfileViewInModal] = (0, react_1.useState)();
    //create modal
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [isMounted]);
    const onClickCreateProject = (0, react_1.useCallback)(() => {
        setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
    }, [createProjectModalVisible.nonce]);
    //rename modal
    const [renameProjectModalVisible, setRenameProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onRenameProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setRenameProjectModalVisible({ visible: false });
            setProjectProfileViewInModal(undefined);
        }
    }, [isMounted]);
    const onClickRenameProject = (projectProfileView) => {
        setProjectProfileViewInModal(projectProfileView);
        setRenameProjectModalVisible({ visible: true, nonce: renameProjectModalVisible.nonce + 1 });
    };
    const { loaded: projectsLoaded, inProgress: projectsInProgress } = projectsDataContext.projectsCumulativeInfo.status;
    const hasProjects = !lodash_1.default.isEmpty(projectsDataSource);
    if (projectsLoaded && !hasProjects) {
        return React.createElement(react_router_dom_1.Redirect, { to: AppRouter_1.PATH__HOME });
    }
    return React.createElement("div", null,
        React.createElement(antd_1.PageHeader, { title: "Projects", extra: React.createElement(React.Fragment, null,
                React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: `createProject${createProjectModalVisible.nonce}`, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "projectsPageHeader" }),
                React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: `renameProject${renameProjectModalVisible.nonce}`, visible: renameProjectModalVisible.visible, onDestroy: onRenameProjectModalDestroy, projectView: projectProfileViewInModal, ctx: "projectsPageRename" }),
                React.createElement(antd_1.Space, null,
                    React.createElement(antd_1.Button, { onClick: onClickCreateProject, icon: React.createElement(icons_1.PlusOutlined, null), loading: projectsInProgress, disabled: projectsInProgress },
                        React.createElement("span", null, "Create new project")),
                    React.createElement(antd_1.Button, { icon: React.createElement(icons_1.ReloadOutlined, null), onClick: projectsDataContext.fetchProjects, disabled: projectsInProgress }))) }),
        React.createElement(PageContent_1.PageContent, { topDivider: true },
            React.createElement(PageContent_1.PageContent.Card, null,
                React.createElement(antd_1.List, { dataSource: projectsDataSource, renderItem: (currentProjectData) => {
                        const { view: { project: projectProfileView, participant } } = currentProjectData;
                        const { projectApiKey, projectName } = projectProfileView;
                        const projectCreationDateTime = DateTimeUtils_1.DateTimeUtils.formatDate(projectProfileView.createdTimeSeconds * 1000, "dayTimeSeconds");
                        const items = [{ key: "rename", label: "Rename", onClick: () => onClickRenameProject(projectProfileView) }];
                        const dropdown = appICUtils_1.ParticipantUtils.hasProjectEditAccess(participant) ? React.createElement(antd_1.Dropdown, { overlay: React.createElement(antd_1.Menu, { items: items }), trigger: ["click"], placement: "bottomRight" },
                            React.createElement(antd_1.Button, { type: "link", icon: React.createElement(icons_1.MoreOutlined, { style: { fontSize: "20px" } }) })) : null;
                        const projectCardTitle = React.createElement(ProjectCardTitle_1.ProjectCardTitle, { projectApiKey: projectApiKey, projectName: projectName });
                        return React.createElement(antd_1.List.Item, { key: projectApiKey, className: `projectRow` },
                            React.createElement(antd_1.PageHeader, { title: projectCardTitle, className: "ant-card-bordered", extra: dropdown },
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Api Key: ",
                                    React.createElement(antd_1.Typography.Text, { copyable: true, className: "apiKey" }, projectApiKey)),
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Created: ",
                                    projectCreationDateTime,
                                    " UTC"),
                                React.createElement(antd_1.Typography.Paragraph, null,
                                    "Please find integration instructions on the ",
                                    React.createElement("a", { href: AppRouter_1.PathGenerator.github.home(), target: "_blank", style: { textDecoration: "underline" } }, "Github"))));
                    }, rowKey: (item) => `${item.view.project.projectApiKey}`, grid: { gutter: 16, column: 1, }, loading: projectsInProgress }))));
};
exports.ProjectsPage = ProjectsPage;
